// extracted by mini-css-extract-plugin
export default {"inputContainer":"InputWithLabel_inputContainer__b5yYl","icon":"InputWithLabel_icon__i72Hd"};